/* eslint-disable react/prop-types */
import React from "react";
import HotKey from "@churchofjesuschrist/eden-hotkey";

const NoOutlineStyles = _ref => {
  let {
    onSelfDestruct
  } = _ref;
  return /*#__PURE__*/React.createElement("style", null, /*#__PURE__*/React.createElement(HotKey, {
    sequence: ["Tab"],
    onMatch: onSelfDestruct
  }), `@supports not selector(:focus-visible) {
        * {
          outline: 0;
        }
      }`);
};

export default NoOutlineStyles;